function localStorageManager(KEY) {
  return {
    get: () => window.localStorage.getItem(KEY),
    set: value => window.localStorage.setItem(KEY, value),
    clear: () => window.localStorage.removeItem(KEY),
  }
}

export const tokenStorage = localStorageManager('TC_auth')
export const newPracticeStorage = localStorageManager('TC_new_practice')
export const userStorage = localStorageManager('TC_user_role')
export const recentPracticeStorage = localStorageManager('TC_recent_practices')
export const recentPracticeIdsStorage = localStorageManager('TC_recent_practice_ids')
export const practiceStorage = localStorageManager('TC_all_practices')



// WEBPACK FOOTER //
// ./src/services/localStorage.js